import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTorch: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="torch, flashlight, inspect"><g clipPath="url(#clip0_15368_27773)"><path d="M10.5 5.5L18.5 13.5" stroke="currentColor" strokeWidth="1.5"/><path d="M2 16.5L9 9.5L9.5 6L13.5 2L22 10.5L18 14.5L14.5 15L7.5 22L2 16.5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9.5 14.5L12 12" stroke="currentColor" strokeWidth="1.5"/></g><defs><clipPath id="clip0_15368_27773"><rect width="24" height="24" fill="white"/></clipPath></defs></CentralIconBase>;
};

export default IconTorch;
